import DateRangePicker from './DateRangePickerModal';

export default DateRangePicker;
